export var OrderType = /*#__PURE__*/ function (OrderType) {
    OrderType["SubscriptionNew"] = "subscription_new";
    OrderType["ManualRenewal"] = "manual_renewal_order";
    OrderType["SubscriptionUpgrade"] = "subscription_upgrade";
    OrderType["Trial"] = "trial";
    OrderType["Renewal"] = "renewal";
    OrderType["PaymentMethodChange"] = "payment_method_change";
    OrderType["PlanChange"] = "plan_change";
    OrderType["Resume"] = "resume";
    OrderType["Upsell"] = "upsell";
    return OrderType;
}({});
export var OrderStatus = /*#__PURE__*/ function (OrderStatus) {
    OrderStatus["Completed"] = "completed";
    OrderStatus["Cancelled"] = "cancelled";
    OrderStatus["Failed"] = "failed";
    OrderStatus["PendingPayment"] = "pending_payment";
    OrderStatus["Refunded"] = "refunded";
    return OrderStatus;
}({});
